export default {
    //获取用户点击过的所有导航
    get_active_nav: state => {
        return state.active_nav;
    },
    //获取当前点击的导航
    get_iNow: state => {
      return state.active_iNow;
    },
    //获取tab标签页的基础数据,该数据会根据tab标签的改变而做出相应改变
    get_tabVisible: state => {
        return state.tabVisible;
    },
    //获取跨模块的原始固定数据
    get_tabVisible_original: state => {
      return state.tabVisible_original;
    },
    //获取车型数据授权子项tab页
    get_carData: state => {
        return state.carData;
    },
    //获取 用户账号列表 子项tab页
    get_accountData: state => {
      return state.accountData;
    },
    //获取 在售机型子项tab页的machineNewOnOff
    get_machineNewOnOff: state=>{
      return state.machineNewOnOff;
    },
    //获取 用户账号列表 产品保修信息
    get_productWarranty: state => {
      return state.productWarranty;
    },
    //获取 用户账号列表 授权
    get_productAuthorize: state => {
      return state.productAuthorize;
    },
    //获取 用户账号列表 授权
    get_historyAuthorize: state => {
      return state.historyAuthorize;
    },
    //页面刷新时,启用sessionStorage的开关
    get_pageRefreshOnOff: state => {
        return state.pageRefreshOnOff;
    }
}



// WEBPACK FOOTER //
// ./src/assets/vuex/getters.js